import React, { useCallback, useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link, Navigate } from 'react-router-dom'
import Loading from '../../../components/loading'
import { ROUTES } from '../../../constants/routes'
import useApi from '../../../hooks/useApi'
import { charityAccountPath } from '../../../lib/charityProfileLink'

export default function CharityAccountPage() {
  const { t } = useTranslation()
  const { getUserCharityRegistrations } = useApi()

  const [verifiedCharities, setVerifiedCharities] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchRegistrations = useCallback(async () => {
    setLoading(true)
    const { data } = await getUserCharityRegistrations()
    const verified = (data || []).filter(
      reg => reg.verified && reg.status === 'Verified',
    )
    setVerifiedCharities(verified)
    setLoading(false)
  }, [getUserCharityRegistrations])

  useEffect(() => {
    fetchRegistrations()
  }, [fetchRegistrations])

  if (loading) {
    return <Loading show />
  }

  if (verifiedCharities.length === 0) {
    return (
      <div className="container mt-4">
        <Alert variant="info">
          {t('charities.settings.no_verified_charities')}
        </Alert>
        <Link to="/charities">{t('charities.settings.back_to_charities')}</Link>
      </div>
    )
  }

  if (verifiedCharities.length === 1) {
    const charityId = verifiedCharities[0].charity?.id
    const path = charityAccountPath(charityId)
    if (path) {
      return <Navigate to={path} replace />
    }
  }

  return (
    <div className="container mt-4 mb-5">
      <h1 className="fs-1">{t('charities.settings.select_charity_title')}</h1>
      <p className="text-muted">
        {t('charities.settings.select_charity_message')}
      </p>
      <ul className="list-group">
        {verifiedCharities.map(registration => {
          const charity = registration.charity
          const path = charityAccountPath(charity?.id)
          if (!path) return null
          return (
            <li className="list-group-item" key={registration.id}>
              <Link to={path}>
                {charity?.organization_name}
                {charity?.ein ? ` (EIN ${charity.ein})` : ''}
              </Link>
            </li>
          )
        })}
      </ul>
      <div className="mt-3">
        <Link to={ROUTES.CHARITY_DASHBOARD}>
          {t('navigation_banner.my_charities_dashboard')}
        </Link>
      </div>
    </div>
  )
}
